import type {
  AuthState,
  CustomUserClaims,
  UserClaims,
} from '@okta/okta-auth-js';

import type { UserProfile } from '~/modules/auth/types';

export function getUserProfile(authState: AuthState): UserProfile {
  const claims = authState.accessToken?.claims as Partial<
    UserClaims<CustomUserClaims & UserProfile>
  >;

  const {
    businessUnit = '',
    jobFamilyGroup = '',
    team = '',
    label = '',
    title = '',
    countryCode = '',
    organization = '',
    company = '',
    userType = '',
    description = undefined,
    department = undefined,
  } = claims || {};

  return {
    businessUnit,
    jobFamilyGroup,
    team,
    label,
    title,
    countryCode,
    organization,
    company,
    userType,
    description,
    department,
  };
}
